import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-liucheng",
  "use": "icon-liucheng-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-liucheng\"><path d=\"M249.89 249.89H774.1V774.1H249.89V249.89z m43.69 43.69v436.84h436.84V293.58H293.58z\" fill=\"#3D4265\" p-id=\"1804\" /><path d=\"M97 97h393.16v393.16H97z\" fill=\"#386BF3\" p-id=\"1805\" /><path d=\"M533.84 533.84H927V927H533.84z\" fill=\"#C3D2FB\" p-id=\"1806\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol